(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-newsletter"] && !Shopify.designMode) return;
  try {
    
    /* Newsletter: submit in the background so the page doesn't reload.

       Shopify's bot protection (hCaptcha) also handles this form. Its script
       stops the normal submit, gets an invisible captcha token, then calls
       form.submit(). It saves the form's submit() the first time it binds to
       the form (on first focus), so we replace form.submit() at page load
       with our background request: Shopify then calls ours, with the token
       already in the form. When the captcha isn't active (theme editor, or
       bot protection turned off) nothing stops the submit, so we send it
       ourselves.

       Anything unexpected (captcha challenge, network error, odd response)
       falls back to a normal submit so signups are never lost. That reloads
       the page, so the scroll position is saved first and put back on the
       next load, and the post-submit query params and form anchor are
       removed from the URL. */
    (function () {
        if (window.__nlv2Init) return;
        window.__nlv2Init = true;

        var FORM_SELECTOR = '.nlv2__form';
        var SCROLL_KEY = 'nlv2:scroll';
        var SCROLL_MAX_AGE = 10 * 60 * 1000;
        var nativeSubmit = HTMLFormElement.prototype.submit;

        function saveScroll() {
            try {
                sessionStorage.setItem(SCROLL_KEY, JSON.stringify({
                    path: window.location.pathname,
                    y: window.scrollY,
                    time: Date.now()
                }));
            } catch (e) {}
        }

        function clearScroll() {
            try {
                sessionStorage.removeItem(SCROLL_KEY);
            } catch (e) {}
        }

        function onReady(callback) {
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', callback);
            } else {
                callback();
            }
        }

        /* ---- After a reload: clean the URL, put the scroll back ---- */

        try {
            var url = new URL(window.location.href);
            var hash = url.hash.indexOf('#NewsletterV2Form-') === 0 ? '' : url.hash;
            var posted = url.searchParams.has('customer_posted');
            if (posted || hash !== url.hash) {
                url.searchParams.delete('customer_posted');
                if (url.searchParams.get('form_type') === 'customer') {
                    url.searchParams.delete('form_type');
                    url.searchParams.delete('form_key');
                }
                history.replaceState(history.state, '', url.pathname + url.search + hash);
            }
        } catch (e) {}

        var saved = null;
        try {
            saved = JSON.parse(sessionStorage.getItem(SCROLL_KEY));
        } catch (e) {}

        if (saved && Date.now() - saved.time > SCROLL_MAX_AGE) {
            clearScroll();
            saved = null;
        }

        /* Only on the page the form was sent from — a captcha challenge
           page in between keeps the saved position for the way back */
        if (saved && saved.path === window.location.pathname) {
            clearScroll();

            var cancelled = false;
            var cancel = function () {
                cancelled = true;
            };
            ['wheel', 'touchstart', 'keydown'].forEach(function (type) {
                window.addEventListener(type, cancel, { once: true, passive: true });
            });

            /* Repeated as the page fills in, so late layout (images, fonts,
               the browser's own jump to the form anchor) can't move it */
            var restore = function () {
                if (!cancelled) window.scrollTo(0, saved.y);
            };
            restore();
            onReady(restore);
            window.addEventListener('load', function () {
                restore();
                requestAnimationFrame(restore);
            });
        }

        /* Move focus to a server-rendered message without scrolling to it */
        onReady(function () {
            var target = document.querySelector(
                FORM_SELECTOR + ' .nlv2__input[aria-invalid="true"], ' + FORM_SELECTOR + ' > .nlv2__message--success'
            );
            if (target) {
                try {
                    target.focus({ preventScroll: true });
                } catch (e) {}
            }
        });

        /* ---- Submitting ---- */

        function fallbackSubmit(form) {
            saveScroll();
            nativeSubmit.call(form);
        }

        function showError(status, text) {
            var p = document.createElement('p');
            p.className = 'nlv2__message nlv2__message--error';
            p.setAttribute('role', 'alert');
            p.textContent = text;
            status.replaceChildren(p);
        }

        function send(form) {
            if (form.__nlv2Busy) return;
            if (!window.fetch || !window.FormData) {
                fallbackSubmit(form);
                return;
            }

            var status = form.querySelector('[data-nlv2-status]');
            var button = form.querySelector('.nlv2__button');
            var email = form.querySelector('.nlv2__input');
            var sectionId = form.id.replace('NewsletterV2Form-', '');

            /* Hide any server-rendered message from an earlier submit */
            form.querySelectorAll(':scope > .nlv2__message').forEach(function (el) {
                el.hidden = true;
            });
            status.replaceChildren();
            form.__nlv2Busy = true;
            button.disabled = true;

            fetch(form.action, {
                method: 'POST',
                body: new FormData(form),
                credentials: 'same-origin'
            })
                .then(function (response) {
                    if (response.url.indexOf('/challenge') !== -1) {
                        throw new Error('captcha challenge');
                    }

                    return response.text().then(function (html) {
                        var doc = new DOMParser().parseFromString(html, 'text/html');
                        var error = doc.getElementById('NewsletterV2Error-' + sectionId);

                        if (error) {
                            showError(status, error.textContent.trim());
                        } else if (
                            response.ok &&
                            (response.url.indexOf('customer_posted=true') !== -1 || doc.querySelector('.nlv2__message--success'))
                        ) {
                            status.replaceChildren(form.querySelector('[data-nlv2-success]').content.cloneNode(true));
                            email.value = '';
                        } else {
                            throw new Error('unexpected response ' + response.status + ' ' + response.url);
                        }

                        clearScroll();
                        form.__nlv2Busy = false;
                        button.disabled = false;
                    });
                })
                .catch(function (err) {
                    console.warn('Newsletter: falling back to a normal submit', err);
                    form.__nlv2Busy = false;
                    fallbackSubmit(form);
                });
        }

        /* Must run before Shopify's captcha binds to the form, so it saves
           (and later calls) our submit() instead of the browser's own */
        function patch(form) {
            if (form.__nlv2Patched || form.hasAttribute('data-hcaptcha-bound')) return;
            form.__nlv2Patched = true;
            try {
                form.submit = function () {
                    send(form);
                };
            } catch (e) {}
        }

        document.querySelectorAll(FORM_SELECTOR).forEach(patch);

        /* Forms added later (theme editor), patched on first focus — capture
           phase, so this still runs before Shopify's own focus listener */
        document.addEventListener('focusin', function (event) {
            var form = event.target.closest && event.target.closest(FORM_SELECTOR);
            if (form) patch(form);
        }, true);

        document.addEventListener('submit', function (event) {
            var form = event.target;
            if (!form.matches || !form.matches(FORM_SELECTOR)) return;

            if (event.defaultPrevented) {
                /* Shopify's captcha has taken over — it calls form.submit()
                   (ours) once it has a token. Save the scroll position in
                   case it ends in a normal submit instead. */
                saveScroll();
                return;
            }

            event.preventDefault();
            send(form);
        });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-cards"] && !Shopify.designMode) return;
  try {
    
    /*
        Product cards (custom): change collection pages without reloading.
        Pagination links keep their normal ?page=N href, so with JavaScript
        off (or if the request fails) they work as a regular page load.
    */
    (function () {
        if (window.__productCardsPagination) return;
        window.__productCardsPagination = true;

        var SELECTOR = '[data-product-cards-results]';

        function fetchPage(url) {
            return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
                .then(function (response) {
                    if (!response.ok) throw new Error('Request failed');
                    return response.text();
                })
                .then(function (html) {
                    return new DOMParser().parseFromString(html, 'text/html');
                });
        }

        function swapResults(container, doc) {
            var id = container.getAttribute('data-product-cards-results');
            var fresh = doc.querySelector(SELECTOR + '[data-product-cards-results="' + id + '"]');
            if (!fresh) throw new Error('Results not found');
            container.innerHTML = fresh.innerHTML;
        }

        function keepInView(container) {
            var header = parseFloat(
                getComputedStyle(document.documentElement).getPropertyValue('--header-height')
            ) || 120;
            if (container.getBoundingClientRect().top < header) {
                container.scrollIntoView({ block: 'start', behavior: 'smooth' });
            }
            container.focus({ preventScroll: true });
        }

        function load(container, url, push) {
            container.setAttribute('aria-busy', 'true');
            fetchPage(url)
                .then(function (doc) {
                    swapResults(container, doc);
                    if (push) {
                        history.pushState({ productCards: true }, '', url);
                    }
                    container.removeAttribute('aria-busy');
                    keepInView(container);
                })
                .catch(function () {
                    window.location.href = url;
                });
        }

        document.addEventListener('click', function (event) {
            var link = event.target.closest && event.target.closest('a[href]');
            if (!link) return;
            var container = link.closest(SELECTOR);
            if (!container || !link.closest('.pagination')) return;
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

            event.preventDefault();
            var url = new URL(link.href, window.location.href);
            url.hash = '';
            load(container, url.toString(), true);
        });

        window.addEventListener('popstate', function () {
            document.querySelectorAll(SELECTOR).forEach(function (container) {
                load(container, window.location.href, false);
            });
        });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
